import {useEffect, useState} from 'react'
import {useDispatch, useSelector} from 'react-redux'

// rsuite
import Table from 'rsuite/Table'
import Tooltip from 'rsuite/Tooltip'
import Whisper from 'rsuite/Whisper'

// icons

// includes
import Edit2 from '@rsuite/icons/Edit'
import TrashIcon from '@rsuite/icons/Trash'
import {toast} from 'react-toastify'
import {SortType} from 'rsuite-table/lib/@types/common'
import IconButton from 'rsuite/esm/IconButton'
import Pagination from 'rsuite/Pagination'
import RSuiteTable from 'src/cms/helpers/components/rsuiteTable'

import * as categoryType from 'src/app/modules/common'
import CheckPermissions from 'src/app/modules/common/checkPermission'
import {StateParamsModel} from 'src/app/modules/common/Model'
import * as news from '../index'

import {isEmpty} from 'lodash'
import checkMultiLanguage from 'src/app/modules/common/checkMultiLanguage'
import DeleteModal from 'src/app/modules/common/components/deleteModal'
import DesignComponent from 'src/app/modules/common/components/designComponent'
import {IPushNotificationTemplateState} from '../index'
import AddPushNotificationTemplate from './AddPushNotificationTemplate'

const PushNotificationTemplate = () => {
  const dispatch = useDispatch()
  const [open, setOpen] = useState(false)
  const [actionType, setActionType] = useState('Add')
  const [params, setParams] = useState<StateParamsModel>({
    page: 1,
    limit: 10,
  })
  const [checkedValues, setCheckedValues] = useState<Array<string>>([])
  const [editSelectedData, setEditCheckedData] = useState<any>()
  const [selectedData, setSelectedData] = useState<Array<string>>([])
  // alert modal
  const [alertOpen, setAlertOpen] = useState(false)
  const handleAlertOpen = () => setAlertOpen(true)
  const handleAlertClose = () => setAlertOpen(false)
  const pushNotificationTemplateData: IPushNotificationTemplateState = useSelector(
    (state: any) => state.pushNotificationTemplate
  )

  const {
    activateSuccess,
    deactivateSuccess,
    singleActivateSuccess,
    singleDeactivateSuccess,
    loading,
    deleteSuccess,
  } = pushNotificationTemplateData

  // const { data: categoryTypeData } = useSelector((state: any) => state.categoryType)

  useEffect(() => {
    dispatch(news.actions.getPushNotificationTemplate(params))
  }, [params])

  useEffect(() => {
    dispatch(categoryType.action.getCategoryType())
  }, [])

  const handleChangeLimit = (dataKey: number) => {
    setParams({
      ...params,
      limit: dataKey,
    })
  }

  const ActionCell = ({rowData, dataKey, ...props}: any) => {
    return (
      <Cell {...props} className='link-group' data-cy='news-link-group'>
        <CheckPermissions type='Edit'>
          <Whisper placement='top' trigger='hover' speaker={<Tooltip>Edit</Tooltip>}>
            <IconButton
              appearance='subtle'
              onClick={() => {
                setEditCheckedData(rowData)
                setActionType('Edit')
                setOpen(true)
              }}
              icon={<Edit2 />}
              data-cy='edit-button'
            />
          </Whisper>
        </CheckPermissions>
        <CheckPermissions type='Delete'>
          <Whisper placement='top' trigger='hover' speaker={<Tooltip>Delete</Tooltip>}>
            <IconButton
              appearance='subtle'
              onClick={() => {
                handleAlertOpen()
                let keySettingId = [rowData.id]
                setCheckedValues(keySettingId)
              }}
              icon={<TrashIcon />}
              data-cy='delete-button'
            />
          </Whisper>
        </CheckPermissions>
      </Cell>
    )
  }

  const Cell = Table.Cell

  const handleClose = () => setOpen(false)

  const columns = [
    {
      label: 'S.N.',
      dataKey: 'sn',
      width: 60,
      cell: <Cell dataKey='sn' />,
    },
    {
      label: 'Notification Title',
      dataKey: 'title',
      flexGrow: 1,
      cell: <Cell dataKey='title' />,
      sortable: true,
    },
    {
      label: 'Action',
      width: 150,
      align: 'center',
      cell: <ActionCell dataKey='id' />,
    },
  ]

  const columnNext = [
    {
      label: 'S.N.',
      dataKey: 'sn',
      width: 60,
      cell: <Cell dataKey='sn' />,
    },
    {
      label: 'Notfication Title',
      dataKey: 'title',
      flexGrow: 1,
      cell: <Cell dataKey='title' />,
      sortable: true,
    },

    {
      label: 'Action',
      width: 150,
      align: 'center',
      cell: <ActionCell dataKey='id' />,
    },
  ]
  useEffect(() => {
    if (deleteSuccess) {
      dispatch(news?.actions.getPushNotificationTemplate(params))
      toast.success('Push notification template deleted successfully')
    }
  }, [pushNotificationTemplateData])

  const handleCheck = (data: any) => {
    setSelectedData(data)
  }

  const handleSort = (dataKey: string, sortType?: SortType) => {
    setParams({...params, orderBy: dataKey, order: sortType})
  }

  const handleChecked = (values: any) => {
    setCheckedValues(values)
  }

  const data = pushNotificationTemplateData?.data?.push_notification_messages
    ? pushNotificationTemplateData?.data?.push_notification_messages?.map(
        (item: any, i: number) => ({
          sn: (params?.page - 1) * params?.limit + (i + 1),
          id: item?.id,
          title: item?.title,
          body: item?.body,
          image: item?.image,
          message_data: {
            type: item?.message_data?.type,
            redirect_to: item?.message_data?.redirect_to,
            image: item?.message_data?.image,
          },
        })
      )
    : []
  const handleAddModal = () => {
    setEditCheckedData({})
    setOpen(true)
    setActionType('Add')
  }

  const modalSubmit = () => {
    let id = checkedValues?.map((value) => ({id: value}))
    dispatch(news?.actions?.deletePushNotificationTemplate(id))
    handleAlertClose()
    handleRefresh()
  }

  const handleRefresh = () => {
    dispatch(news?.actions.getPushNotificationTemplate(params))
  }
  const multiLanguage = checkMultiLanguage()
  return (
    <>
      <div className='shadow p-3 bg-white rounded' data-cy='news-shadow-comp'>
        <DesignComponent
          moduleName='Push Notification Template'
          params={params}
          setParams={setParams}
          handleRefresh={handleRefresh}
          handleAddModal={handleAddModal}
          handleAlertOpen={handleAlertOpen}
          exportShow={false}
          importShow={false}
          toggleMultipleShow={false}
          data-cy='news-design-comp'
        />
        <div className='datatable' data-cy='news-data-table'>
          <RSuiteTable
            onChecked={handleChecked}
            showCheckbox={true}
            columns={multiLanguage ? columnNext : columns}
            data={data}
            showLoading={loading}
            checkedValues={checkedValues}
            handleSort={handleSort}
            data-cy='news-r-suite'
          />
          <Pagination
            prev
            next
            first
            last
            ellipsis
            boundaryLinks
            className='mt-5'
            maxButtons={5}
            size='sm'
            layout={['total', '-', 'limit', '|', 'pager', 'skip']}
            total={pushNotificationTemplateData?.data?.meta?.total || 0}
            limitOptions={[10, 20, 50, 100]}
            limit={params?.limit}
            activePage={params?.page}
            onChangePage={(value) => setParams({...params, page: value})}
            onChangeLimit={handleChangeLimit}
            data-cy='news-pagination'
          />

          <AddPushNotificationTemplate
            open={open}
            params={params}
            handleClose={handleClose}
            actionType={actionType}
            editSelectedData={editSelectedData}
          />
        </div>
        <>
          {alertOpen &&
            (!isEmpty(checkedValues) ? (
              <DeleteModal
                handleClick={() => modalSubmit()}
                isOpen={alertOpen}
                handleClose={() => handleAlertClose()}
              />
            ) : (
              toast.error('No data selected') && setAlertOpen(false)
            ))}
        </>
      </div>
    </>
  )
}

export default PushNotificationTemplate
